import { RequirementConditionType } from 'services/automation/types';

export const getAutomationTypesOptions = ({
  atsJobId,
  atsListId,
  documentTypesAvailableOptions
}: {
  documentTypesAvailableOptions: string[];
  atsJobId: string | null | undefined;
  atsListId: string | null | undefined;
}) => {
  const automationTypes = [];

  if (atsJobId || atsListId) {
    automationTypes.push({
      label: 'Change  status',
      value: RequirementConditionType.CONVERSATION_STATUS_CONDITION
    });
  }

  if (documentTypesAvailableOptions.length) {
    automationTypes.push({
      label: 'Upload document',
      value: RequirementConditionType.CONVERSATION_DOCUMENT_UPLOAD_CONDITION
    });
  }

  return automationTypes;
};
